<template>
  <div class="content">
    <div class="content-logo">
      <img src="@/assets/logoCan.png" width="100rem" height="100rem" />
    </div>
    <div class="text-center">
      <p class="sub-item">
        {{ data ? data.footer.pie_pagina : '' }}
      </p>
      <p class="sub-item">
        {{ data ? data.footer.direccion : '' }}
      </p>
      <p class="sub-item">
        <a target="_blank" :href="'mailto:'.concat(data ? data.footer.correo_electronico_entidad : '')"> {{  data ? data.footer.correo_electronico_entidad : '' }} </a>  
      </p>
      <p class="sub-item">
        <a target="_blank" :href="data ? data.web_alcaldia : ''"> {{  data ? data.web_alcaldia : '' }} </a>  
      </p>
      <p class="sub-item">
        <a target="_blank" :href="data ? data.baner.web_empresa : ''"> &#169; CananguchalSoft ZOMAC </a>  
      </p>
    </div>
    <img class="flag" :src="data ? data.logo_alcaldia : ''" width="100rem" height="60rem" />
  </div>
</template>

<script>

export default {
  name: "Footer",
  props: {
    data: Object
  }
};
</script>

<style scoped>

.text-center{
    text-align: center;
}

.sub-item{
    margin-bottom: 0rem;
}

.content{
    display: flex;
    justify-content: space-between;
    align-items: center;
}


@media (max-width: 650px) {
  .content {
    display: block;
  }

  .flag{
    display: none;  
  }

  .content-logo{
    width: 100%;
    text-align: center;
  }
}

</style>
